import { apiFetch } from './client.js';

function buildQuery(params) {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      qs.set(key, String(value));
    }
  });
  const query = qs.toString();
  return query ? `?${query}` : '';
}

export function listItems(workspaceId, params = {}) {
  return apiFetch(`/workspaces/${workspaceId}/items${buildQuery(params)}`);
}

export function getItem(itemId) {
  return apiFetch(`/items/${itemId}`);
}

export function createItem(workspaceId, payload) {
  return apiFetch(`/workspaces/${workspaceId}/items`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function updateItem(itemId, payload) {
  return apiFetch(`/items/${itemId}`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
}

export function deleteItem(itemId) {
  return apiFetch(`/items/${itemId}`, { method: 'DELETE' });
}
